import { useEffect, useState, useCallback } from "react";
import { GetCRMItems } from "../../../actions/CRM";

const CRMLibrarian = ({ items }) => {
  const keys = [
    "email",
    "url",
    "format",
    "submissions",
    "expedite",
    "withdraw",
    "librarians",
  ];

  useEffect(() => {
    console.log(items);
  }, [items]);

  return (
    <div className="crm-card">
      <div className="crm-journal">
        <div className="crm-journal-header">Test</div>
      </div>
      <div className="crm-card-content">test@gmail.com</div>;
    </div>
  );
};

export default CRMLibrarian;
